function isTripAutomaticallyPlanned(trip) {
  return !!trip.demandIds?.length;
}

export default isTripAutomaticallyPlanned;
